export default __webpack_public_path__ + "static/media/colors_4.ac93abf7.mp4";